








































































































































import DpaNewsItem from "@dpa-id-components/dpa-news-item";
import DpaFilterBadge from "@dpa-id-components/dpa-filter-badge";
import UiIcon from "@dpa-id-components/ui-icon";
import UiIconButton from "@dpa-id-components/ui-icon-button";
import UiTooltip from "@dpa-id-components/ui-tooltip";
import UiMenu from "@dpa-id-components/ui-menu";
import UiList from "@dpa-id-components/ui-list";
import UiListItem from "@dpa-id-components/ui-list-item";

import "@dpa-id-components/dpa-news-item/dist/DpaNewsItem.css";
import "@dpa-id-components/dpa-filter-badge/dist/DpaFilterBadge.css";
import "@dpa-id-components/ui-icon/dist/UiIcon.css";
import "@dpa-id-components/ui-tooltip/dist/UiTooltip.css";
import "@dpa-id-components/ui-icon-button/dist/UiIconButton.css";
import "@dpa-id-components/ui-menu/dist/UiMenu.css";
import "@dpa-id-components/ui-list/dist/UiList.css";
import "@dpa-id-components/ui-list-item/dist/UiListItem.css";

import { Vue, Component, Prop } from "vue-property-decorator";
import { computed, toRefs } from "vue";
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import format from "date-fns/format";
import locale from "date-fns/locale/de";
import { Location } from "vue-router";
import colors from "vuetify/es5/util/colors";
import CdkClassification from "@dpa-connect/dpa-connect-classification";
import { NewsItem } from "@/store/modules/newsItems/types.d";
import {
  getNewsItemStatus,
  getNewsItemStatusTooltip,
  getClassificationFilterRules
} from "@/store/modules/newsItems/getters";
import { isMobile } from "@/utils/responsive";
import { VALID_SIGNAL } from "@/constants/pubStatus";
import SlcNewsItemLong from "./SlcNewsItemLong/SlcNewsItemLong.vue";
import SlcNewsItemShort from "./SlcNewsItemShort/SlcNewsItemShort.vue";
import {
  FilterPassBadge,
  createFilterPassBadge,
  filterIsVisible,
  sortByIsPublic
} from "@/utils/filterPassBadges";
import useMarkAsFavorite from "@/composition/useMarkAsFavorite";
import useSetFilterRules from "@/composition/useSetFilterRules";
import CdkFavoriteIcon from "@/components/CdkFavorite/CdkFavoriteIcon.vue";
import useAuthentication from "@/composition/useAuthentication";
import getResidref from "@/utils/remoteMedia";
import getCurrentView from "@/composition/getCurrentView";
import useMatomoEvent from "@/composition/useMatomoEvent";
import useKeywordTracking from "@/composition/useKeywordTracking";

import useSharingActions from "@/composition/useSharingActions";
import CdkImage from "./ContentRows/CdkImage.vue";
import getPlainText from "@/components/CdkNewsItem/lib/getPlainText";
import useNewsItem from "@/composition/useNewsItem";
import SlcAddToFolderDialog from "./lib/SlcAddToFolderDialog.vue";
import useCollaboration from "@/composition/useCollaboration";
import getGenre from "./lib/getGenre";
import useShareViaEmail from "./lib/useShareViaEmail";
import usePDFExport from "./lib/usePDFExport";

@Component({
  props: {
    sortedFolders: {
      type: Array,
      default: []
    }
  },
  setup(props, context) {
    const { toggleFavorite } = useMarkAsFavorite();
    const { handleTagClick } = useSetFilterRules();
    const { validateAndRetrieveToken } = useAuthentication();
    const { copyToClipboard, download } = useSharingActions();

    const {
      fetchNewsItem,
      newsItemDetail,
      newsItemDetailPlainTextProps,
      hasRemoteContent
    } = useNewsItem(context);

    const showFirstFolder = () => {
      return props.sortedFolders[0];
    };

    const trackOpenDetailViewEvent = () => {
      useMatomoEvent({
        category: `${getCurrentView()} View`,
        action: `Click ${getCurrentView()}-View-Item`,
        name: `Open Detail View in ${getCurrentView()}-View`
      });
    };

    const { trackKeywordClickEvent } = useKeywordTracking();

    const onFavoriteIconClick = (isFavorite: boolean) => {
      useMatomoEvent({
        category: `${getCurrentView()} View`,
        action: `Click Favorite-Icon in ${getCurrentView()}-View`,
        name: `${getCurrentView()} List Favorites`
      });

      if (!isFavorite) {
        // @ts-ignore
        // eslint-disable-next-line no-unused-expressions
        window.Appcues?.track("Item(s) saved as favorite");
      }
    };

    const { newsItem } = toRefs(props);

    const {
      setFolderItemsQueryVariables,
      sidebarFolder,
      addToFolder
    } = useCollaboration(newsItem);

    const handleMenuOpen = () => {
      setFolderItemsQueryVariables(sidebarFolder.value);
      useMatomoEvent({
        category: `${getCurrentView()} View`,
        action: `Click Interaction-menu in ${getCurrentView()}-View`,
        name: `Click Interaction-menu on ${getCurrentView()}-View-Interaction-Item`
      });
    };

    const trackDownloadEvent = () => {
      useMatomoEvent({
        category: `${getCurrentView()} View`,
        action: `Click "Bild herunterladen" within ${getCurrentView()}-View-Interaction menu`,
        name: `Download within ${getCurrentView()}-View-Interaction-Menu`
      });
    };

    const trackAddToFolderEvent = () => {
      useMatomoEvent({
        category: `${getCurrentView()} View`,
        action: `Click "Zur Mappe hinzufügen" within ${getCurrentView()}-View-Interaction menu`,
        name: `Zu Mappe hinzufügen within ${getCurrentView()}-View-Interaction-Menu`
      });
    };

    const emailSharing = computed(() => useShareViaEmail(newsItemDetail));

    // @ts-ignore
    const pdfExport = usePDFExport(newsItem);

    return {
      copyToClipboard,
      download,
      trackDownloadEvent,
      trackAddToFolderEvent,
      addToFolder,
      fetchNewsItem,
      getPlainText,
      handleTagClick,
      newsItemDetail,
      newsItemDetailPlainTextProps,
      onFavoriteIconClick,
      showFirstFolder,
      toggleFavorite,
      token: validateAndRetrieveToken,
      trackKeywordClickEvent,
      trackOpenDetailViewEvent,
      handleMenuOpen,
      hasRemoteContent,
      emailSharing,
      pdfExport
    };
  },
  components: {
    long: SlcNewsItemLong,
    short: SlcNewsItemShort,
    DpaNewsItem,
    DpaFilterBadge,
    CdkClassification,
    CdkFavoriteIcon,
    CdkImage,
    UiIcon,
    UiTooltip,
    UiIconButton,
    UiMenu,
    UiList,
    UiListItem,
    SlcAddToFolderDialog
  },
  computed: {
    ...mapState("stageconfig", ["config"]),
    ...mapState("collaboration", ["isSidebarVisible", "selectedFolder"]),
    ...mapGetters("filters", ["getFilterByLink"]),
    ...mapGetters("collaboration", ["isIdSelected", "isSelectionEnabled"])
  },
  methods: {
    ...mapMutations("collaboration", [
      "removeEvent",
      "unselectBatch",
      "closeSidebar",
      "openSidebar",
      "setSelectedFolder"
    ]),
    ...mapActions("collaboration", ["addEvent"])
  }
})
export default class SlcNewsItemProvider extends Vue {
  @Prop({
    type: Object || undefined,
    default: () => undefined
  })
  eventBus: any | undefined;

  @Prop() newsItem!: NewsItem;

  @Prop() view!: string;

  @Prop() isExpanded!: boolean;

  @Prop({ required: false }) remoteContent!: any;

  @Prop({ required: false }) itemClass!: string | null | undefined;

  getFilterByLink: any | boolean;

  isIdSelected: (id: string) => boolean;

  addEvent: (e: { id: string; event: object }) => void;

  removeEvent: (id: string) => void;

  unselectBatch: () => void;

  openSidebar: () => void;

  setSelectedFolder: (folder) => void;

  showFirstFolder: () => void;

  sortedFolders: any;

  selectedFolder: boolean;

  isSidebarVisible: boolean;

  isSelectionEnabled: boolean;

  config: any;

  currentDate: Date = new Date();

  currentDateInterval: number = null;

  fetchNewsItem: () => void;

  newsItemDetail: any;

  $vuetify: any;

  get date(): string {
    return format(this.newsItem.versionCreated, "DD.MM.YYYY", { locale });
  }

  get time(): string {
    return format(this.newsItem.versionCreated, "HH:mm", { locale });
  }

  get status(): string {
    return getNewsItemStatus(this.newsItem);
  }

  // NB: Retrieves text for tooltip based on ednote with a valid signal type
  get tooltip(): string {
    return getNewsItemStatusTooltip({
      ...this.newsItem,
      ednote: this.ednote
    });
  }

  get description(): string {
    return this.newsItem.description.length
      ? this.newsItem.description[0].text
      : "";
  }

  // REVIEW: Mapping of tags to corresponding filterRule, e.g. Ressort tag -> FILTER_CATEGORY
  get classificationFilterRules() {
    return getClassificationFilterRules(this.newsItem);
  }

  // WIP: Needs adjustment
  get tags(): any[] {
    return this.classificationFilterRules;
  }

  get isUrgent(): boolean {
    return this.newsItem.urgency === 1 || this.newsItem.urgency === 2;
    // return true;
  }

  get isEmbargoed(): boolean {
    return !!this.newsItem.embargoed;
  }

  // Weather a detail view is being displayed
  get isActive(): boolean {
    return this.$route.params.id !== undefined;
  }

  get to(): Location {
    return {
      path: `/newsitems/${this.$route.params.viewMode}/${this.newsItem.guid}`,
      query: this.$route.query
    };
  }

  get backgroundColor(): string {
    return this.isUrgent ? colors.red.lighten5 : "#fff";
  }

  // NB: mapping of ednote to valid/usable signals.
  get ednote() {
    return (this.newsItem.ednote || []).map(n => ({
      text: n.text,
      role: n.role.match(VALID_SIGNAL)
        ? n.role.match(VALID_SIGNAL)[0].split("/")[1]
        : "" // wip, should use regex match
    }));
  }

  get newsItemProps() {
    const {
      view,
      newsItem,
      date,
      time,
      status,
      tooltip,
      description,
      tags,
      isUrgent,
      isEmbargoed,
      filterPassBadges,
      isActive
    } = this;
    const {
      guid,
      genre,
      headline,
      wordCount,
      embargoed,
      remoteContent,
      itemClass,
      addedAt
    } = newsItem;
    return {
      guid,
      date,
      time,
      genre: getGenre(genre, guid, getResidref(remoteContent, itemClass)),
      title: headline[0],
      isUrgent,
      isEmbargoed,
      ...(isEmbargoed
        ? {
            embargoed: `${format(embargoed, "DD. MMMM, HH:mm", { locale })} Uhr`
          }
        : {}),
      ...(view === "long" || this.componentToRender === "DpaNewsItem"
        ? {
            tags,
            wordCount,
            pubStatus: status,
            description,
            tooltip
          }
        : {}),
      // REVIEW: Adjust component, when state is expanded.
      // isMobile: isMobile(this) || this.isExpanded,
      isMobile: isMobile(this),
      ...(view === "short"
        ? {
            isActive
          }
        : {}),
      filterPassBadges,
      residref: getResidref(remoteContent, itemClass),
      layoutOrientation: remoteContent[0]
        ? remoteContent[0].layoutOrientation
        : null,
      addedAt
    };
  }

  /**
   * Map filter pass badges from store into the component and change view model.
   * TODO: Filter only by id, not by complete link URI.
   */
  get filterPassBadges(): FilterPassBadge[] {
    const newsItem: any = { ...this.newsItem };
    return newsItem.filterPassBadges
      .filter(uri => !!this.getFilterByLink(uri))
      .map(uri => createFilterPassBadge(this.getFilterByLink(uri)))
      .filter(filterIsVisible)
      .sort(sortByIsPublic);
  }

  token: Function;

  get authJWT() {
    return this.token();
  }

  get shouldDisplay() {
    if (this.config.features.enableGraphics) return true;
    return this.newsItem.itemClass !== "graphic";
  }

  get showNewBadge() {
    return (
      this.newsItem.addedAt &&
      this.newsItem.addedAt.getTime() >= this.currentDate.getTime() - 300000
    );
  }

  created() {
    setInterval(() => (this.currentDate = new Date()), 1000);
  }

  beforeDestroy() {
    clearInterval(this.currentDateInterval);
  }

  isHovering: boolean = false;

  /**
   * If the current id matches the selection
   * @returns {Boolean}
   */
  get isSelected() {
    return this.isIdSelected(this.newsItem.guid);
  }

  /**
   * Adds or removes event objects to the store
   * @returns {Void}
   */
  set isSelected(isChecked) {
    if (isChecked) {
      this.addEvent({ id: this.newsItem.guid, event: this.newsItem });
    } else {
      this.removeEvent(this.newsItem.guid);
      this.unselectBatch();
    }
  }

  /**
   * If the checkbox should be shown
   * @returns {Boolean}
   */
  get isCheckboxVisible() {
    return this.$vuetify.breakpoint.mdAndUp;
  }

  get checkboxOpacity() {
    return {
      opacity: this.isHovering || this.isSelected ? "100%" : "0"
    };
  }

  handleSidebarVisibility() {
    if (!this.isSidebarVisible) {
      if (this.selectedFolder == null) {
        this.setSelectedFolder(this.showFirstFolder());
      }
      this.openSidebar();

      useMatomoEvent({
        category: `${getCurrentView()} View`,
        action: `Click checkbox next to item in ${getCurrentView()}-View`,
        name: `Collab-Checkbox in ${getCurrentView()} View`
      });
    }
    return null;
  }

  // TODO: Remove once feature flag is put to prod
  get componentToRender(): string {
    if (this.view === "short") {
      if (this.config.features.enableNewsItemRedesign) {
        return "DpaNewsItem";
      }
      return "short";
    }
    return "long";
  }

  // TODO: Extract, DRYness
  get viewVariant(): string {
    if (this.view === "short") {
      return "compact";
    }
    return "standard";
  }

  visibilityChanged(isVisible) {
    if (isVisible) {
      this.$store.dispatch("newsItems/fetchImage", {
        isThumbnail: this.view === "short",
        residref: this.newsItemProps.residref,
        guid: this.newsItemProps.guid
      });
    }
  }

  // NB: this function works under the assumption that the newsitem has already
  // been fetched by opening the menu. This is a necessary workaround so the
  // clipbaord can be written to on iOS 15. hasRemoteContent and newsItemProps
  // are reactive to the data is. coming from fetchNewsItem.
  copyText() {
    // @ts-ignore
    if (this.hasRemoteContent) {
      // @ts-ignore
      this.copyToClipboard(this.newsItemProps.description);
    } else {
      // @ts-ignore
      this.copyToClipboard(getPlainText(this.newsItemDetailPlainTextProps));
    }

    useMatomoEvent({
      category: `${getCurrentView()} View`,
      action: `Click "Text kopieren" within ${getCurrentView()}-View-Interaction menu`,
      name: `Text kopieren within ${getCurrentView()}-View-Interaction-Menu`
    });
  }
}
